import { Icon } from '@iconify/react';
import { Box, Divider, Tooltip, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

const ChatBubble = ({ id, role, content, sources }) => {
  const isUser = role === 'user';

  return (
    <Box display="flex" justifyContent={isUser ? 'flex-end' : 'flex-start'} my={1}>
      <Box
        sx={{
          maxWidth: '80%',
          p: 1,
          px: 2,
          bgcolor: isUser ? '#7d5ae8' : '#f1f1f1',
          color: isUser ? '#fff' : '#000',
          borderRadius: 3,
        }}
      >
        <div style={{ lineHeight: '1.6', marginTop: 0 }}>
          <ReactMarkdown>{content.replace(/\[ENSURING\]|\[ENSURED\]/g, '')}</ReactMarkdown>
        </div>
        {sources?.length > 0 && (
          <Box>
            <Divider sx={{ mb: 0.8 }} />
            <Typography fontWeight="bold" textAlign="left">
              Sources
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
              {sources.map((source) => (
                <Tooltip key={source.id} title="Open in New Tab">
                  <Typography
                    component="a"
                    href={`/interview/${id}/transcripts/${source.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    color="#7d5ae8"
                    sx={{ cursor: 'pointer' }}
                  >
                    <span style={{ verticalAlign: 'middle' }}>
                      {/* {getTranscriptName(transcriptId)} */}
                      {source.name || source.id}
                    </span>
                    <Icon
                      icon="mdi:open-in-new"
                      width="20"
                      height="20"
                      style={{ verticalAlign: 'middle', marginLeft: 4 }}
                    />
                  </Typography>
                </Tooltip>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ChatBubble;
